<div class="dialog">
    <p class="text-end">
        <span mat-button mat-dialog-close (click)="refreshList()">
            <svg xmlns="http://www.w3.org/2000/svg" width="13.998" height="13.998" viewBox="0 0 13.998 13.998">
                <path id="close-btn"
                    d="M8.177-11.911,6.768-13.32l-5.59,5.59-5.59-5.59L-5.82-11.911l5.59,5.59L-5.82-.732-4.411.677l5.59-5.59L6.768.677,8.177-.732l-5.59-5.59Z"
                    transform="translate(5.82 13.32)" fill="#bbb" />
            </svg>
        </span>
    </p>
    <div class="suspend">
        <img src="assets/images/addnewImage.svg" alt="">
        <h4 class="title" *ngIf="data.type == 'add'">{{'items-requests.Item added successfully' | translate}}</h4>
        <h4 class="title" *ngIf="data.type == 'request'">{{"items-requests.Item's request submitted successfully" |
            translate}}</h4>

        <div class="hint" *ngIf="data.type == 'add'">
            {{'items-requests.Once the suspension' | translate}} </div>

        <div class="actions group_btn">
            <button mat-button *ngIf="data.type == 'add'" (click)="onCreateAuction()"
                class="btnLight_fill">{{'items-requests.Add another Item' |
                translate}}</button>
            <button mat-button class="btn_fill" mat-dialog-close (click)="refreshList()" type="submit">
                {{'items-requests.Ok, I got it' | translate}}
            </button>
        </div>

    </div>
</div>